import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'who_is_responsible_for_paying_recruitment_fees_and_related_cost'

export const dataPointDefinition = {
  retracedId: 'who_is_responsible_for_paying_recruitment_fees_and_related_cost',
  name: 'Who is responsible for paying recruitment fees and related costs, the worker or the facility?',
  description:
    'The terms "recruitment fees" or "related costs" refer to any fees or costs incurred in the recruitment process in order for workers to secure employment or placement, regardless of the manner, timing or location of their imposition or collection. \r\r\n\r\r\nNOTE: If all or some of the costs of recruitment are paid for by the recruiting agent, please consider this as a cost ultimately paid for by the Facility.\r\r\n\r\r\nWhen initiated by an employer; required to secure access to employment or placement; or imposed during the recruitment process, the following costs should be considered related to the recruitment process:\r\r\ni. Medical costs: payments for medical examinations, tests or vaccinations;\r\r\nii. Insurance costs: costs to insure the lives, health and safety of workers, including enrollment in migrant welfare funds;\r\r\niii. Costs for skills and qualification tests: costs to verify workers’ language proficiency and level of skills and qualifications, as well as for location-specific credentialing, certification or licensing;\r\r\niv. Costs for training and orientation: expenses for required trainings, including on-site job orientation and pre-departure or post-arrival orientation of newly recruited workers;\r\r\nv. Equipment costs: costs for tools, uniforms, safety gear, and other equipment needed to perform assigned work safely and effectively;\r\r\nvi. Travel and lodging costs: expenses incurred for travel, lodging and subsistence within or across national borders in the recruitment process, including for training, interviews, consular appointments, relocation, and return or repatriation;\r\r\nvii. Administrative costs: application and service fees that are required for the sole purpose of fulfilling the recruitment process. These could include fees for representation and services aimed at preparing, obtaining or legalizing workers’ employment contracts, identity documents, passports, visas, background checks, security and exit clearances, banking services, and work and residence permits. \r\r\nhttps://www.ilo.org/wcmsp5/groups/public/---ed_protect/---protrav/---migrant/documents/publication/wcms_536755.pdf',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Facility',
      key: 'FAC',
      slcpIndex: 1,
      slcpOptionName: 'rec-res',
    },
    {
      name: 'Worker Only',
      key: 'WORKER_ONLY',
      slcpIndex: 2,
      slcpOptionName: 'rec-res',
    },
    {
      name: 'Facility and Worker',
      key: 'FAC_AND_WORKER',
      slcpIndex: 3,
      slcpOptionName: 'rec-res',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['FAC', 'WORKER_ONLY', 'FAC_AND_WORKER'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4900,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
